const nf0 = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 });
const compact = new Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 });

export const fmtUnits = (v: number | null | undefined) => (v == null ? "—" : nf0.format(v));
export const fmtCompact = (v: number | null | undefined) => (v == null ? "—" : compact.format(v));
export const fmtSigned = (v: number | null | undefined) =>
  v == null ? "—" : `${v > 0 ? "+" : v < 0 ? "−" : ""}${nf0.format(Math.abs(v))}`;
export const fmtPct = (v: number | null | undefined) =>
  v == null ? "—" : `${v > 0 ? "+" : v < 0 ? "−" : ""}${nf1.format(Math.abs(v))}%`;
export const fmtMoney = (v: number | null | undefined) =>
  v == null ? "—" : new Intl.NumberFormat(undefined, { style: "currency", currency: "USD", notation: "compact", maximumFractionDigits: 1 }).format(v);

export function fmtMonth(m: string): string {
  const [y, mo] = m.split("-").map(Number);
  if (!y || !mo) return m;
  return new Date(y, mo - 1, 1).toLocaleDateString(undefined, { month: "short", year: "2-digit" });
}

export function timeAgo(iso?: string): string {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export function clockTime(iso?: string): string {
  return iso ? new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "";
}

export const STATUS_LABEL: Record<string, string> = {
  draft: "Draft", queued: "Queued", running: "Running", executed: "Done", invalid: "Not done",
  failed: "Failed", interrupted: "Interrupted", conversational: "Answered", cancelled: "Cancelled",
  staged: "Staged", needs_confirmation: "Confirm scope", discarded: "Discarded",
};

export function scopeLabel(scope: { family: string; group1: string; group2?: string; skus: string[] }): string {
  // Levels can repeat a name (family "Tablets", group "Tablets"): show it once.
  const parts = [scope.family, scope.group1, scope.group2].filter((p, i, all) => p && p !== all[i - 1]) as string[];
  if (scope.skus?.length) parts.push(scope.skus.length === 1 ? scope.skus[0] : `${scope.skus.length} SKUs`);
  return parts.join(" · ") || "All SKUs";
}
